import axios from '@/apis/axios';

class Compliance 
{
    static async all()
    {
        const response = await axios.get('/api/compliance/import-list');

        return response.data.data;
    }

    static async create(data)
    {
        const response = await axios.post('/api/compliance', data);

        return response.data.data;
    }

    static async update(id, data)
    {
        const response = await axios.put(`/api/compliance/${id}`, data);

        return response.data;
    }

    static async reUpload(id, data)
    {
        const response = await axios.post(`api/compliance/${id}/re-upload`, data);

        return response.data.data;
    }

    static async delete(id)
    {
        const response = await axios.delete(`/api/compliance/${id}`);

        return response.data;
    }

    static async getLiveStatus(id)
    {
        const response = await axios.get(`api/compliance/${id}`);

        return response.data;
    }

    static async getCategoryRelatedDetails(id)
    {
        const response = await axios.get(`api/compliance/${id}/getDetails`);

        return response.data.data;
    }

    static async systemScreening(id, type)
    {
        const response = await axios.post(`api/compliance/${id}/check-entire-system`, type);

        return response.data.data;
    }

    static async scanSelectedRecords(type, records)
    {
        const response = await axios.post(`api/compliance/scan/${type}`, { records });

        return response.data.data;
    }

    static async masScreening(searchKeyword)
    {
        const response = await axios.get(`api/compliance/mas-screening/${searchKeyword}`);

        return response.data;
    }

    static async generateReport(searchKeyword)
    {
        const response = await axios.post(`api/compliance/generate-report/${searchKeyword}`, [],{
            responseType: 'blob'
        });

        return response.data;
    }

    static async checkedComplianceData(id, type) {
        const response = await axios.put(`api/compliance/${id}/${type}/checked`);

        return response.data;
    }
}

export default Compliance;